import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { useT } from "../lib/i18n";

const CITY_KEYS = [
  { name: "Kissimmee", zips: ["34741", "34744", "34746"] },
  { name: "Ocala", zips: ["34470", "34471", "34472"] },
  { name: "Orlando", zips: ["32801", "32819", "32836"] },
];

export default function Locations() {
  const { t } = useT();
  return (
    <section
      id="locations"
      className="bg-black py-20 md:py-28 border-t border-white/10"
      data-testid="locations-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-12 gap-6 md:gap-10 mb-10 md:mb-14 items-end">
          <div className="md:col-span-8">
            <p className="overline mb-3">{t("locations.overline")}</p>
            <h2 className="font-display text-white text-4xl md:text-5xl lg:text-6xl leading-[0.95]">
              {t("locations.headingPrefix")}
              <br />
              <span className="text-[color:var(--primary)]">Kissimmee.</span>{" "}
              <span>Ocala.</span> <span>Orlando.</span>
            </h2>
          </div>
          <div className="md:col-span-4 text-white/60 text-sm md:text-base leading-relaxed">
            {t("locations.subhead")}
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-0 border border-white/10">
          {CITY_KEYS.map((c, i) => (
            <motion.article
              key={c.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.06 }}
              className={`p-6 md:p-8 relative group bg-black hover:bg-[color:var(--bg-elev)] transition-colors duration-500 ${
                i !== CITY_KEYS.length - 1
                  ? "md:border-r md:border-white/10 border-b md:border-b-0 border-white/10"
                  : ""
              }`}
              data-testid={`location-${c.name.toLowerCase()}`}
            >
              <div className="flex items-center gap-2 text-[color:var(--primary)]">
                <MapPin size={14} />
                <p className="overline text-[color:var(--primary)]">
                  {t(`locations.cities.${c.name}.tagline`)}
                </p>
              </div>
              <h3 className="mt-3 font-display text-white text-4xl md:text-5xl leading-none group-hover:text-[color:var(--primary)] transition-colors">
                {c.name}
              </h3>
              <p className="mt-4 text-sm text-white/60 leading-relaxed">
                {t(`locations.cities.${c.name}.body`)}
              </p>
              <div className="mt-6 flex flex-wrap gap-1.5 text-[9px] uppercase tracking-widest font-mono text-white/40">
                {c.zips.map((z) => (
                  <span key={z} className="border border-white/15 px-1.5 py-0.5">
                    {z}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
